 export const GET_ALL_RECIPES_HOME = 'GET_ALL_RECIPES_HOME'
 export const GET_RECIPE_BY_ID = 'GET_RECIPE_BY_ID'
 export const GET_RECIPE_BY_NAME = 'GET_RECIPE_BY_NAME'
 export const ORDER_ALPHABETIC_ASC = 'ORDER_ALPHABETIC_ASC'
 export const ORDER_ALPHABETIC_DES = 'ORDER_ALPHABETIC_DESC'
 export const ORDER_BY_HIGH_SCORE= 'ORDER_BY_HIGH_SCORE'
 export const ORDER_BY_LOW_SCORE= 'ORDER_BY_LOW_SCORE'
 export const GET_TYPES_OF_DIET= 'GET_TYPES_OF_DIET'
 export const FILTER_RECIPES_BY_DIET= 'FILTER_RECIPES_BY_DIET'
 export const POST_RECIPE= 'POST_RECIPE'
 export const DELETE_RECIPE= 'DELETE_RECIPE'
 export const RESET = 'RESET'


